import React from 'react';
import Title from 'components/UI/Title';
import RadioBtn from 'components/UI/RadioBtn';
import * as styles from './radioButton.module.scss';

export default function Mobile({ sectionName, values, items, onChangeCount }) {
  const onChange = item => onChangeCount(item);

  const clickHandler = (item, value) => {
    if (value) {
      onChangeCount(item, !value);
    }
  };

  return (
    <ul className={styles.list}>
      {items.map(item => (
        <li key={item} className={styles.item}>
          <RadioBtn
            onChange={() => onChange(item)}
            onClick={() => clickHandler(item, values[item])}
            name={`${sectionName}Mobile`}
            checked={values[item]}
            value={item}
          >
            <Title tag="p" size="h3" className={styles.itemTitle}>
              {item}
            </Title>
          </RadioBtn>
        </li>
      ))}
    </ul>
  );
}
